import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const Testimonials = () => {
    const testimonials = [
        {
            name: "Juan Pérez",
            text: "La calidad de las gorras es impresionante. No solo son cómodas, sino que también tienen un diseño increíble. ¡Muy recomendado!",
            image: "https://via.placeholder.com/80", // Reemplazar con la URL de la imagen del cliente.
        },
        {
            name: "María García",
            text: "El servicio al cliente fue excepcional. Me ayudaron a encontrar justo lo que estaba buscando y el envío fue rápido.",
            image: "https://via.placeholder.com/80", // Reemplazar con la URL de la imagen del cliente.
        },
        {
            name: "Carlos López",
            text: "Nunca pensé que una gorra podría tener tanta calidad. Me encanta cómo se ajusta y el diseño está a otro nivel.",
            image: "https://via.placeholder.com/80", // Reemplazar con la URL de la imagen del cliente.
        },
    ];

    return (
        <Container className="my-5">
            <h2 className="text-uppercase text-muted mb-3 fs-6">Testimonios</h2>
            <h3 className="fw-bold text-black fs-2">Esto dicen nuestro clientes</h3>
            <Row>
                {testimonials.map((testimonial, index) => (
                    <Col md={4} key={index} className="mb-4">
                        <Card className="h-100 shadow-sm bg-black">
                            <Card.Body className="text-center text-white">
                                <Card.Text className="text-white mb-2">"{testimonial.text}"</Card.Text>
                                <Card.Title className="fw-bold">{testimonial.name}</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Testimonials;
